"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CalendarItinerarySmallFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_CalendarItinerarySmallFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.875h4V3.5a1 1 0 1 0 2 0V1.904c.588.036 1.006.116 1.362.298a3 3 0 0 1 .756.548h.007v.007a3 3 0 0 1 .548.756c.194.381.273.832.305 1.487H1.022c.032-.655.11-1.106.305-1.487a3 3 0 0 1 .548-.756V2.75h.007a3 3 0 0 1 .756-.548c.356-.182.774-.262 1.362-.298V3.5a1 1 0 0 0 2 0V1.875ZM1 6.675 1.001 6h13.998l.001.675v1.173a2.715 2.715 0 0 0-.5-.046h-3a2.7 2.7 0 0 0-2.7 2.7V15h-3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-.756-.548h-.007v-.007a3 3 0 0 1-.548-.756C1 12.72 1 11.88 1 10.2V6.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2ZM11.5 9.002a1.5 1.5 0 0 0-1.5 1.5v4.75c0 .668.75 1 1.28.53l1.72-1.72 1.72 1.72a.75.75 0 0 0 1.28-.53v-4.75a1.5 1.5 0 0 0-1.5-1.5h-3Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_CalendarItinerarySmallFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = CalendarItinerarySmallFill;
exports["default"] = _default;